import React from "react";
import { Menu as MantineMenu } from "@mantine/core";
import styled, { css } from "styled-components";
import zIndices from "theme/z-indices";
const Menu = ({
  children = void 0,
  closeOnItemClick = true,
  keepMounted = void 0,
  offset = void 0,
  onChange = void 0,
  onClose = void 0,
  opened = void 0,
  portalProps = void 0,
  position = void 0,
  shadow = void 0,
  width = void 0,
  withinPortal = false,
  zIndex = zIndices.dropdownMenu
}) => /* @__PURE__ */ React.createElement(
  MantineMenu,
  {
    closeOnItemClick,
    onClose,
    shadow,
    opened,
    onChange,
    portalProps,
    width,
    position,
    withinPortal,
    keepMounted,
    offset,
    zIndex
  },
  children
);
const StyledMenuItem = styled(MantineMenu.Item)(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};
    font-size: ${theme.fonts.size.body};
    white-space: nowrap;

    &:hover,
    &:focus {
      text-decoration: none;
      color: inherit;
      background-color: ${theme.utils.colorLevel(theme.colors.global.contentBackground, 10)};
    }
  `
);
const StyledMenuDivider = styled(MantineMenu.Divider)(
  ({ theme }) => css`
    border-color: ${theme.colors.variant.lighter.default};
  `
);
const StyledMenuLabel = styled(MantineMenu.Label)(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.small};
    color: ${theme.colors.text.secondary};
  `
);
Menu.Target = MantineMenu.Target;
Menu.Dropdown = styled(MantineMenu.Dropdown)(
  ({ theme }) => css`
    && {
      background-color: ${theme.colors.global.contentBackground};
      border: 1px solid ${theme.colors.variant.lighter.default};
    }
  `
);
Menu.Item = StyledMenuItem;
Menu.Divider = StyledMenuDivider;
Menu.Label = StyledMenuLabel;
export default Menu;
